var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`height:${_vm.height}`),attrs:{"id":"gaode-map"}},[_c('div',{attrs:{"id":"gaodeMap"}}),_c('input',{attrs:{"id":"keywordSearch","placeholder":"地区关键字"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }